/* tslint:disable */
/* eslint-disable */
/**
 * NoRadio Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, localDateString } from '../runtime';
import type { FileUrl } from './FileUrl';
import { FileUrlFromJSON, FileUrlFromJSONTyped, FileUrlToJSON } from './FileUrl';

/**
 *
 * @export
 * @interface EpisodeModel
 */
export interface EpisodeModel {
    /**
     *
     * @type {string}
     * @memberof EpisodeModel
     */
    id: string;
    /**
     *
     * @type {string}
     * @memberof EpisodeModel
     */
    title: string;
    /**
     *
     * @type {string}
     * @memberof EpisodeModel
     */
    html: string;
    /**
     *
     * @type {number}
     * @memberof EpisodeModel
     */
    episodeNumber: number;
    /**
     *
     * @type {string}
     * @memberof EpisodeModel
     */
    showId: string;
    /**
     *
     * @type {Date}
     * @memberof EpisodeModel
     */
    originalDate: Date;
    /**
     *
     * @type {string}
     * @memberof EpisodeModel
     */
    content: string;
    /**
     *
     * @type {string}
     * @memberof EpisodeModel
     */
    shortContent: string;
    /**
     *
     * @type {FileUrl}
     * @memberof EpisodeModel
     */
    fileUrl?: FileUrl;
}

/**
 * Check if a given object implements the EpisodeModel interface.
 */
export function instanceOfEpisodeModel(value: object): boolean {
    if (!('id' in value)) return false;
    if (!('title' in value)) return false;
    if (!('html' in value)) return false;
    if (!('episodeNumber' in value)) return false;
    if (!('showId' in value)) return false;
    if (!('originalDate' in value)) return false;
    if (!('content' in value)) return false;
    return 'shortContent' in value;
}

export function EpisodeModelFromJSON(json: any): EpisodeModel {
    return EpisodeModelFromJSONTyped(json, false);
}

export function EpisodeModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): EpisodeModel {
    if (json == null) {
        return json;
    }
    return {
        id: json['id'],
        title: json['title'],
        html: json['html'],
        episodeNumber: json['episode_number'],
        showId: json['show_id'],
        originalDate: new Date(json['original_date']),
        content: json['content'],
        shortContent: json['short_content'],
        fileUrl: json['file_url'] == null ? undefined : FileUrlFromJSON(json['file_url']),
    };
}

export function EpisodeModelToJSON(value?: EpisodeModel | null): any {
    if (value == null) {
        return value;
    }
    return {
        id: value['id'],
        title: value['title'],
        html: value['html'],
        episode_number: value['episodeNumber'],
        show_id: value['showId'],
        original_date: localDateString(value['originalDate']),
        content: value['content'],
        short_content: value['shortContent'],
        file_url: FileUrlToJSON(value['fileUrl']),
    };
}
